
import { Utils } from "../../utils/Utils";

export default function SubscriptionPlanCard({ plan, isLoading, onPurchase }) {
	const description = (plan.description ?? "").trim();

	return (
		<article
			className={[
				"relative flex h-full min-h-[420px] flex-col overflow-hidden rounded-[16px]",
				"border border-darkBlue/10 bg-white",
				"shadow-[0_8px_24px_rgba(39,106,166,0.08)]",
			].join(" ")}
		>
			<div
				className="h-[3px] w-full shrink-0 bg-gradient-to-l from-cta via-[#FF8A6B] to-darkBlue"
				aria-hidden
			/>
			<div className="flex min-h-0 flex-1 flex-col p-5 md:p-6">
				<h2 className="h-[3.25rem] overflow-hidden font-Vazir-700 text-[18px] leading-[1.625rem] text-darkBlue line-clamp-2">
					{plan.title}
				</h2>
				<p
					className={[
						"mt-2 h-[2.75rem] overflow-hidden font-Vazir-400 text-[14px] leading-[1.375rem] line-clamp-2",
						description ? "text-darkBlue/60" : "invisible",
					].join(" ")}
					aria-hidden={!description}
				>
					{description || "\u00a0"}
				</p>

				<div className="mt-5 h-8 shrink-0">
					<p className="font-Vazir-700 text-[26px] leading-none text-cta">
						{Utils.convertTomanComma(plan.price)}
						<span className="mr-1 font-Vazir-500 text-[13px] text-darkBlue/55">
							تومان
						</span>
					</p>
				</div>

				<ul className="mt-5 shrink-0 space-y-2 font-Vazir-400 text-[13px] text-darkBlue">
					<li className="min-h-[40px] rounded-[10px] bg-lightCta/80 px-3 py-2">
						اعتبار زمانی:{" "}
						<span className="font-Vazir-600">{plan.duration_days} روز</span>
					</li>
					<li className="min-h-[40px] rounded-[10px] bg-lightCta/80 px-3 py-2">
						محدودیت استفاده:{" "}
						<span className="font-Vazir-600">{plan.usage_limit}</span>
					</li>
				</ul>

				<div className="min-h-4 flex-1" aria-hidden />

				<button
					type="button"
					disabled={isLoading}
					onClick={() => onPurchase(plan)}
					className={[
						"mt-5 w-full shrink-0 rounded-[12px] py-3 font-Vazir-600 text-[14px] text-white",
						"bg-gradient-to-l from-cta to-[#FF825E] shadow-[0_4px_14px_rgba(255,106,75,0.35)]",
						"transition hover:brightness-105 active:scale-[0.99] disabled:opacity-60",
						"focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-darkBlue/30 focus-visible:ring-offset-2",
					].join(" ")}
				>
					{isLoading ? "در حال انتقال به درگاه..." : "خرید اشتراک"}
				</button>
			</div>
		</article>
	);
}
